import { Component, EventEmitter, Input, numberAttribute, Output } from '@angular/core';
import { DataAccessScreensizeFacade } from '@planone/bau365/data-access-screensize';
import { Observable } from 'rxjs';

import { PageChangedEvent } from './paginator.model';

@Component({
  selector: 'planone-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent {
  @Input({ transform: numberAttribute }) set pageIndex(pageIndex: number | null) {
    if (!pageIndex || isNaN(pageIndex)) {
      this.currentPage = 0;
    } else {
      this.currentPage = Math.ceil(pageIndex);
    }
  }

  @Input() set pageCount(pageCount: number | null) {
    if (!pageCount) return;
    const length = Math.ceil(pageCount);
    this.pages = Array.from({ length }, (_, index) => index);
  }

  @Input() useDesktopAppearanceInMobile = false;

  @Output() pageChanged = new EventEmitter<PageChangedEvent>();

  currentPage = 0;
  pages: number[] = [];
  mobilePages: number[] = [];

  get lastPage() {
    return this.pages[this.pages.length - 1];
  }

  screenSize$: Observable<string | undefined>;

  constructor(private screenSizeFacade: DataAccessScreensizeFacade) {
    this.screenSize$ = this.screenSizeFacade.size$;
  }

  navigatePreviousPage() {
    this.pageChanged.emit({ pageIndex: this.currentPage - 1 });
  }

  navigateNextPage() {
    this.pageChanged.emit({ pageIndex: this.currentPage + 1 });
  }

  firePageChangedEvent(pageIndex: number) {
    this.pageChanged.emit({ pageIndex });
  }

  isPageVisible(pageIndex: number) {
    return (
      (pageIndex <= this.currentPage + 2 && pageIndex >= this.currentPage) ||
      (pageIndex >= this.currentPage - 2 && pageIndex <= this.currentPage) ||
      pageIndex === this.currentPage
    );
  }

  prepareMobileMenu() {
    this.calculateMobilePages(this.currentPage);
  }

  mobileMenuUp(event: Event) {
    event.stopPropagation();
    const reference = this.mobilePages[1];
    this.calculateMobilePages(reference - 1);
  }

  mobileMenuDown(event: Event) {
    event.stopPropagation();
    const reference = this.mobilePages[1];
    this.calculateMobilePages(reference + 1);
  }

  private calculateMobilePages(referencePage: number) {
    const sliceMin = 0;
    const sliceMax = this.pages.length;

    if (sliceMax < 3) {
      this.mobilePages = this.pages.slice(sliceMin, sliceMax);
      return;
    }

    let sliceFrom = referencePage - 1;
    if (sliceFrom < sliceMin) sliceFrom++;
    let sliceTo = referencePage + 2;
    if (sliceFrom === sliceMin && sliceTo - sliceFrom < 3) sliceTo++;
    if (sliceTo > sliceMax) sliceTo = sliceMax;
    if (sliceTo === sliceMax && sliceTo - sliceFrom < 3) sliceFrom--;
    this.mobilePages = this.pages.slice(sliceFrom, sliceTo);
  }

  identifyPage(_index: number, page: number): string {
    return `${page}`;
  }
}
